import { render } from "./CompanyUpdate.vue?vue&type=template&id=71a8e4c8"
import script from "./CompanyUpdate.vue?vue&type=script&lang=js"
export * from "./CompanyUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__